import type { ChangeEvent } from 'react'
import { useEffect } from 'react'

import SearchIcon from '@/assets/icons/icon-search.svg'
import { CalendarRangeDatePicker } from '@/components/ui/calendar/calendar-range-date-picker.tsx'
import { TextField } from '@/components/ui/text-field.tsx'
import { WithRefresher } from '@/components/ui/with-refresher.tsx'

import { usePpvTracking } from '../hooks/usePpvTracking.tsx'

interface QueryPanelProps {
  setSearch?: (search: string) => void
  refetch?: () => void
}

export const PpvTrackingQueryPanel = ({
  setSearch,
  refetch: refetchContent,
}: QueryPanelProps) => {
  const { setDate, date, isFetching, refetch } = usePpvTracking()

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch?.(event.target.value)
  }

  useEffect(
    () => {
      /*
                          We need to reset each search state when move to another page
                          because we don't bind text input to the state value
                        */
      return () => setSearch?.('')
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  return (
    <>
      {setSearch && (
        <TextField
          type="text"
          placeholder="Search"
          onChange={handleSearchChange}
          prefix={
            <SearchIcon className="text-secondary-500 dark:text-secondary-300" />
          }
          className="text-sm"
        />
      )}
      <WithRefresher
        onRefresh={() => {
          refetch()
          if (refetchContent) refetchContent()
        }}
        isFetching={isFetching}
      >
        <CalendarRangeDatePicker
          date={date}
          setDate={setDate}
        />
      </WithRefresher>
    </>
  )
}
